export default "__VITE_ASSET__Cc1O8bXl__"